/* eslint-disable react/button-has-type */
import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import Spinner, {
  Color as SpinnerColor,
  Size as SpinnerSize,
} from 'components/Common/Spinner';

import classes from './Button.module.scss';

export const Size = Object.freeze({
  L: 'large',
  S: 'small',
});

export const Kind = Object.freeze({
  Primary: 'primary',
  Secondary: 'secondary',
});

export const Color = Object.freeze({
  Default: 'default',
  Red: 'red',
  Pink: 'pink',
  Green: 'green',
  Black: 'black',
});

export const Type = Object.freeze({
  Default: 'button',
  Reset: 'reset',
  Submit: 'submit',
});

const Button = ({
  size,
  kind,
  type,
  disabled,
  loading,
  isFullWidth,
  children,
  onClick,
  className,
  upperCase,
  color,
}) => (
  <button
    type={type}
    className={classNames(
      classes.button,
      classes[size],
      className,
      classes[kind],
      classes[color],
      {
        [classes.loading]: loading,
        [classes.isFullWidth]: isFullWidth,
        [classes.disabled]: disabled,
        [classes.upperCase]: upperCase,
      }
    )}
    onClick={onClick}
    disabled={disabled}
  >
    {loading ? (
      <Spinner
        color={SpinnerColor.White}
        size={SpinnerSize.S}
        className={classes.spinner}
      />
    ) : (
      children
    )}
  </button>
);

Button.propTypes = {
  children: PropTypes.node.isRequired,
  size: PropTypes.oneOf(Object.values(Size)),
  kind: PropTypes.oneOf(Object.values(Kind)),
  type: PropTypes.oneOf(Object.values(Type)),
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  isFullWidth: PropTypes.bool,
  onClick: PropTypes.func,
  className: PropTypes.string,
  upperCase: PropTypes.bool,
  color: PropTypes.oneOf(Object.values(Color)),
};

Button.defaultProps = {
  size: Size.L,
  kind: Kind.Primary,
  type: Type.Default,
  disabled: false,
  loading: false,
  isFullWidth: false,
  onClick: () => {},
  className: '',
  upperCase: true,
  color: Color.Default,
};

export default Button;
